import { createContext, type ReactNode, useContext } from 'react';
import { createPortal } from 'react-dom';

/**
 * The bar across the top of the page panel. The layout owns the element; pages fill it through
 * `PageBarContent` (title, breadcrumb, actions) so it stays put while the content scrolls.
 */
export const PageBarContext = createContext<HTMLElement | null>(null);

export function PageBarContent({ children }: { children: ReactNode }) {
  const slot = useContext(PageBarContext);
  return slot ? createPortal(children, slot) : null;
}
